import config from './config';
const TOKEN_KEY = 'token';
const UID_KEY = 'uid';
const INFO_KEY= 'info';

const getToken = function() {
  //从配置文件中读取token 若没写入 则从storage中取并写入配置
  let token = config.token;
  if(!token) {
    console.log('Read token from storage.');
    token = getStorage(TOKEN_KEY);
    config.token = token;
  }
  //判断token是否过期 过期返回null
  if(token && Date.now() - token.timestamp > 12 * 60 * 60 * 1000 - 60000) {
    token = null;
  }
  return token;
};

const getUserId = function () {
  return config.uid || sessionStorage.getItem(UID_KEY) || null;
}

const getStorageInfo = function() {
    let info = config.info;
    if(!info) {
      console.log('Read token from storage.');
      info = getStorage(INFO_KEY);
      config.info = info;
    }
    return info;
}

const getUserRole = function() {
  const info = getStorageInfo();
  return info.role || 2;
}

const getUserPositionId = function() {
  const info = getStorageInfo();
  return info.deptInfo?.position_id || void 0;
}

const setToken = function(res) {
  let temp = {
    timestamp: Date.now(),
    token: res.token
  };
  config.token = temp;
  config.info = res.admin;
  config.uid = res.admin.id;
  let value = JSON.stringify(temp);
  sessionStorage.setItem(TOKEN_KEY, value);
  sessionStorage.setItem(INFO_KEY, JSON.stringify(res.admin));
  sessionStorage.setItem(UID_KEY, config.uid);
};

const getStorage = function(key) {
  let result = null;
  let storage = sessionStorage.getItem(key);
  try {
    storage = JSON.parse(storage);
    result = storage;
  } catch (e) {
    console.log(`Storage for ${key} parse failed.`);
  }
  return result;
};

const cleanToken = function() {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(INFO_KEY);
  sessionStorage.removeItem(UID_KEY);
  config.token = null;
  config.info = null;
  config.uid = null;
};

export { getToken, getUserId, getStorage, setToken, cleanToken, getStorageInfo, getUserRole, getUserPositionId }
